/**
 * React Query key factories
 * These provide consistent cache keys for all queries
 */

// Query keys for habits
export const habitsKeys = {
  all: ['habits'] as const,
  lists: () => [...habitsKeys.all, 'list'] as const,
  list: (filters?: string) => [...habitsKeys.lists(), { filters }] as const,
  details: () => [...habitsKeys.all, 'detail'] as const,
  detail: (id: string) => [...habitsKeys.details(), id] as const,
  todayStatus: (id: string) => [...habitsKeys.detail(id), 'today'] as const,
  history: (id: string) => [...habitsKeys.detail(id), 'history'] as const,
}

// Query keys for profile and wallet
export const profileKeys = {
  all: ['profile'] as const,
  detail: () => [...profileKeys.all, 'detail'] as const,
  inventory: () => [...profileKeys.all, 'inventory'] as const,
  fullPage: () => [...profileKeys.all, 'fullPage'] as const,
}

// Query keys for notifications
export const notificationsKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationsKeys.all, 'list'] as const,
  list: (limit: number, offset: number) => [...notificationsKeys.lists(), { limit, offset }] as const,
  unreadCount: () => [...notificationsKeys.all, 'unreadCount'] as const,
}

// Query keys for feed
export const feedKeys = {
  all: ['feed'] as const,
  lists: () => [...feedKeys.all, 'list'] as const,
  list: (limit: number, offset: number) => [...feedKeys.lists(), { limit, offset }] as const,
  infinite: () => [...feedKeys.lists(), 'infinite'] as const,
}

// Query keys for challenges
export const challengesKeys = {
  all: ['challenges'] as const,
  lists: () => [...challengesKeys.all, 'list'] as const,
  detail: (id: string) => [...challengesKeys.all, 'detail', id] as const,
  active: () => [...challengesKeys.all, 'active'] as const,
}

// Query keys for community feed
export const communityKeys = {
  all: ['community'] as const,
  feed: () => [...communityKeys.all, 'feed'] as const,
}

// Query keys for subscription
export const subscriptionKeys = {
  all: ['subscription'] as const,
  status: () => [...subscriptionKeys.all, 'status'] as const,
}

// Query keys for trackers
export const trackersKeys = {
  all: ['trackers'] as const,
  lists: () => [...trackersKeys.all, 'list'] as const,
  details: () => [...trackersKeys.all, 'detail'] as const,
  detail: (id: string) => [...trackersKeys.details(), id] as const,
  history: () => [...trackersKeys.all, 'history'] as const,
}

// Query keys for accountability partnerships
export const partnershipKeys = {
  all: ['partnerships'] as const,
  active: () => [...partnershipKeys.all, 'active'] as const,
  requests: () => [...partnershipKeys.all, 'requests'] as const,
  sharedHabits: (partnershipId: string) => [...partnershipKeys.all, 'sharedHabits', partnershipId] as const,
  mySharedHabitIds: (partnershipId: string) => [...partnershipKeys.all, 'mySharedHabitIds', partnershipId] as const,
  mySharedHabitIdsAll: () => [...partnershipKeys.all, 'mySharedHabitIdsAll'] as const,
  partnerStatus: (partnershipId: string) => [...partnershipKeys.all, 'partnerStatus', partnershipId] as const,
  partnerActivity: (partnershipId: string) => [...partnershipKeys.all, 'activity', partnershipId] as const,
  nudges: (partnershipId: string) => [...partnershipKeys.all, 'nudges', partnershipId] as const,
}
